"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = exports.Icon = exports.SaveButton = exports.CancelButton = exports.StyledUL = exports.StyledGrid = exports.classes = void 0;
var styles_1 = require("@mui/material/styles");
var __1 = require("..");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var colors_1 = require("../ThemeProvider/colors");
var prism_icons_1 = require("@octanner/prism-icons");
var react_1 = __importDefault(require("react"));
var PREFIX = 'PasswordForm';
exports.classes = {
    root: "".concat(PREFIX, "-root"),
    colorPrimary: "".concat(PREFIX, "-colorPrimary"),
    colorSecondary: "".concat(PREFIX, "-colorSecondary"),
    colorWarning: "".concat(PREFIX, "-colorWarning"),
    bar: "".concat(PREFIX, "-bar"),
    barColorPrimary: "".concat(PREFIX, "-barColorPrimary"),
    barColorWarning: "".concat(PREFIX, "-barColorWarning"),
    barColorSecondary: "".concat(PREFIX, "-barColorSecondary"),
};
exports.StyledGrid = (0, styles_1.styled)(__1.Grid)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(exports.classes.root)] = {
            height: 10,
            borderRadius: 10,
        },
        _b["& .".concat(exports.classes.colorPrimary)] = {
            backgroundColor: colors_1.tannerGray['200'],
        },
        _b["& .".concat(exports.classes.colorSecondary)] = {
            backgroundColor: colors_1.tannerGray['200'],
        },
        _b["& .".concat(exports.classes.colorWarning)] = {
            backgroundColor: colors_1.tannerGray['200'],
        },
        _b["& .".concat(exports.classes.bar)] = {
            borderRadius: 0,
        },
        _b["& .".concat(exports.classes.barColorPrimary)] = {
            backgroundColor: colors_1.tannerSemantic['success'].color,
        },
        _b["& .".concat(exports.classes.barColorWarning)] = {
            backgroundColor: '#E5B818',
        },
        _b["& .".concat(exports.classes.barColorSecondary)] = {
            backgroundColor: colors_1.tannerSemantic['error'].color,
        },
        _b);
});
exports.StyledUL = (0, styles_1.styled)('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"])));
exports.CancelButton = (0, styles_1.styled)(__1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 16px;\n  width: 100%;\n"], ["\n  margin-left: 16px;\n  width: 100%;\n"])));
exports.SaveButton = (0, styles_1.styled)(__1.Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
exports.Icon = (0, styles_1.styled)(function (_a) {
    var isValidated = _a.isValidated, isPassed = _a.isPassed, props = __rest(_a, ["isValidated", "isPassed"]);
    if (isValidated) {
        return isPassed ? react_1.default.createElement(prism_icons_1.Check, __assign({}, props)) : react_1.default.createElement(prism_icons_1.Close, __assign({}, props));
    }
    else {
        return (react_1.default.createElement(Typography_1.default, __assign({ component: "span" }, props),
            ' ',
            "\u2022",
            ' '));
    }
})(function (props) {
    var _a, _b;
    var color = 'inherit';
    if (props.isValidated) {
        if (props.isPassed) {
            color = (_a = colors_1.tannerSemantic['success']) === null || _a === void 0 ? void 0 : _a.color;
        }
        else {
            color = (_b = colors_1.tannerSemantic['error']) === null || _b === void 0 ? void 0 : _b.color;
        }
    }
    return {
        width: 16,
        marginRight: props.isValidated ? 20 : 15,
        marginLeft: props.isValidated ? 5 : 10,
        color: color,
    };
});
exports.StyledTypography = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) {
        return !/isHeader|isPassed|isValidated/.test(String(prop));
    },
})(function (props) {
    var color = 'inherit';
    if (props.isValidated) {
        color = props.isPassed
            ? colors_1.tannerSemantic['success'].color
            : colors_1.tannerSemantic['error'].color;
    }
    return {
        display: 'flex',
        alignItems: 'center',
        marginBottom: props.isHeader ? 10 : 5,
        color: color,
    };
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map